export default __webpack_public_path__ + "static/media/Neeraj.c4ac4ca3.jpg";